import { useState, useEffect } from "react";
import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import CostSheetCreate from "./CostSheetCreate";
import EditHeading from "./EditHeading";
import { buttonFunction, rowsFunction } from "./Functions";

export default function RequirementInfo({
  setData,
  initialState,
  setUpdateJobEnquiry,
  jobEnquiryId,
  handleJobEnquiryEdit,
  vBenefit,
  vBenefitValue,
}) {
  const [show, setShow] = useState(false);

  const [defaultRows, setDefaultRows] = useState([]);

  const [rowEdited, setRowEdited] = useState(false);

  useEffect(() => {
    const rows = rowsFunction(initialState, vBenefit);
    setDefaultRows(rows);
  }, [initialState]);

  const [headingPopup, setHeadingPopup] = useState(false);

  return (
    <>
      {headingPopup && (
        <EditHeading
          showPromptElement={headingPopup}
          setShowPromptElement={setHeadingPopup}
          setUpdateJobEnquiry={setUpdateJobEnquiry}
          initialState={initialState}
          jobEnquiryId={jobEnquiryId}
        />
      )}
      <div className=" w-full flex flex-wrap gap-4 ">
        <div className="max-w-sm w-full flex gap-3 items-center h-fit">
          <button
            className="p-1 rounded-md ring-1 ring-slate-200"
            onClick={() => setShow((p) => !p)}
            type="button"
          >
            {show ? (
              <RiArrowDownSLine size={"1.4rem"} />
            ) : (
              <RiArrowRightSLine size={"1.4rem"} />
            )}
          </button>
          <div>
            <h2 className="font-semibold">Requirement Info</h2>
            <p>Provide Requirement Info</p>
          </div>
        </div>
        <div
          className={`w-full  px-4 overflow-hidden ml-auto rounded-md transition-all  ${
            show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
          }`}
        >
          {buttonFunction(setHeadingPopup, rowEdited, handleJobEnquiryEdit)}
          <CostSheetCreate
            quotationDetails={{ type: "" }}
            defaultRows={defaultRows}
            setData={setData}
            setRowEdited={setRowEdited}
            vBenefit={vBenefit}
            vBenefitValue={vBenefitValue}
          />
        </div>
      </div>
    </>
  );
}
